var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"main_container",attrs:{"type":"flex"}},[_c('base-header',[_vm._v("商品上新")]),_c('personal-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }